$(document).ready(function(){
  if($(window).width() > 767){
    $('.slideshow-wrapper .slideshow').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: false,
      dots: false,
      draggable: false,
    });
  }else{
  	$('.slideshow-wrapper .slideshow').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: false,
      dots: true,
    });
  }


    $('.quantity_container .plus').click(function(){
      console.log('clicked');
      let a = $('.quantity_container .product-form__input').val();
      a = parseInt(a);
      $('.quantity_container .product-form__input').val(++a);
    });

    $('.quantity_container .minus').click(function(){
      console.log('clicked');
      let a = $('.quantity_container .product-form__input').val();
      a = parseInt(a);
      a--;
      if(a > 0)      
      	$('.quantity_container .product-form__input').val(a);
    });
});